import * as Types from '../constants/Types';

export const getSaleReport = (params) => ({ type: Types.REPORT_GET_SALE_REPORT_ACTION, params });
export const setSaleReport = (saleReport) => ({ type: Types.REPORT_GET_SALE_REPORT_SUCCESS, saleReport });

export const getSaleReportByOrder = (params) => ({ type: Types.REPORT_GET_SALE_REPORT_BY_ORDER_ACTION, params });
export const setSaleReportByOrder = (saleReportByOrder) => ({ type: Types.REPORT_GET_SALE_REPORT_BY_ORDER_SUCCESS, saleReportByOrder });

export const getSaleReportBySKU = (params) => ({ type: Types.REPORT_GET_SALE_REPORT_BY_SKU_ACTION, params });
export const setSaleReportBySKU = (saleReportBySKU) => ({ type: Types.REPORT_GET_SALE_REPORT_BY_SKU_SUCCESS, saleReportBySKU });

export const getSaleDetailReportBySKU = (params) => ({ type: Types.REPORT_GET_SALE_DETAIL_REPORT_BY_SKU_ACTION, params });
export const setSaleDetailReportBySKU = (saleReportBySKU) => ({ type: Types.REPORT_GET_SALE_DETAIL_REPORT_BY_SKU_SUCCESS, saleReportBySKU });

export const getVoucherRedeemtionReport = (params) => ({ type: Types.REPORT_VOUCHER_REDEEMTION_ACTION, params });
export const setVoucherRedeemtionReport = (voucherRedeemtions, params) => ({ type: Types.REPORT_VOUCHER_REDEEMTION_SUCCESS, voucherRedeemtions, params });

export const getVoucherRedeemtionReportDetail = (params) => ({ type: Types.REPORT_VOUCHER_REDEEMTION_DETAIL_ACTION, params });
export const setVoucherRedeemtionReportDetail = (items, params) => ({ type: Types.REPORT_VOUCHER_REDEEMTION_DETAIL_SUCCESS, items, params });

export const exportVoucherRedeemtions = (params) => ({ type: Types.REPORT_EXPORT_REDEEMTIONS_ACTION, params });

export const getCashFlowReport = (params) => ({ type: Types.REPORT_GET_CASH_FLOW_REPORT_ACTION, params });
export const setCashFlowReport = (cashFlow, params) => ({ type: Types.REPORT_GET_CASH_FLOW_REPORT_SUCCESS, cashFlow, params });

export const getCollaboratorReport = (params) => ({ type: Types.REPORT_GET_COLLABORATOR_REPORT_ACTION, params });
export const setCollaboratorReport = (reports) => ({ type: Types.REPORT_GET_COLLABORATOR_REPORT_SUCCESS, reports });

export const getExportCollaboratorReport = (data) => ({ type: Types.REPORT_EXPORT_COLLABORATOR_REPORT_ACTION, data });
export const setExportCollaboratorReport = (reports) => ({ type: Types.REPORT_EXPORT_COLLABORATOR_REPORT_SUCCESS, reports });

export const getSaleDetailReportByHotel = (params) => ({ type: Types.REPORT_GET_SALE_DETAIL_REPORT_BY_HOTEL_ACTION, params });
export const setSaleDetailReportByHotel = (saleReportByHotel) => ({ type: Types.REPORT_GET_SALE_DETAIL_REPORT_BY_HOTEL_SUCCESS, saleReportByHotel });

export const crossCheckPMSAction = (body, statusCrosscheck) => ({ type: Types.CROSS_CHECK_ACTION, body , statusCrosscheck});
export const setCrossCheckPMS = (reports) => ({ type: Types.CROSS_CHECK_SUCCESS, reports });
export const setDefaultCrossCheckStatus = () => ({type: Types.DEFAULT_CROSS_CHECK_STATUS});

// btb order report
export const getBtbOrderReport = (params) => ({ type: Types.REPORT_GET_BTB_ORDER_REPORT_ACTION, params });
export const setBtbOrderReport = (reports) => ({ type: Types.REPORT_GET_BTB_ORDER_REPORT_SUCCESS, reports });

export const getExportBtbOrderReport = (data) => ({ type: Types.REPORT_EXPORT_BTB_ORDER_REPORT_ACTION, data });
export const setExportBtbOrderReport = (reports) => ({ type: Types.REPORT_EXPORT_BTB_ORDER_REPORT_SUCCESS, reports });
// btb use room report
export const getBtbUseRoomReport = (params) => ({ type: Types.REPORT_GET_BTB_USE_ROOM_REPORT_ACTION, params });
export const setBtbUseRoomReport = (reports) => ({ type: Types.REPORT_GET_BTB_USE_ROOM_REPORT_SUCCESS, reports });

export const getExportBtbUseRoomReport = (data) => ({ type: Types.REPORT_EXPORT_BTB_USE_ROOM_REPORT_ACTION, data });
export const setExportBtbUseRoomReport = (reports) => ({ type: Types.REPORT_EXPORT_BTB_USE_ROOM_REPORT_SUCCESS, reports });
